<template>
    <div class="modal fade" id="intersport-product-modal" tabindex="-1" aria-labelledby="intersport-product-modal"
         aria-hidden="true">
        <div class="modal-dialog">
            <div class="modal-content">
                <LoadingSpinner v-if="peopleStore.loading" />
                <div class="modal-header">
                    <h5 class="modal-title" id="intersport-product-modal">{{ productsStore.openProduct.title }}</h5>
                    <button type="button"
                            class="btn btn-no-styling btn-close"
                            aria-label="Close"
                            data-bs-dismiss="modal">
                        <span class="icon icon-close"></span>
                    </button>
                </div>
                <div>
                    <div class="modal-body">
                      <LoadingSpinner v-if="peopleStore.loadingObject.loading" />
                      <div class="intersport-product-modal__product">
                        <div class="ratio ratio-16x9" v-html="productsStore.openProduct.modalImgHtml"></div>

                        <div class="intersport-product-modal__product-info">
                          <div class="interpsort-product__prices">
                            <div class="interpsort-product__price" v-if="adultPricing">
                              <span class="interpsort-product__price-tag">{{ translate('intersport.adult-price-text') }}</span>
                              <span>{{ translate('intersport.price-from-text') }} <Price :value="adultPricing.price" /></span>
                            </div>

                            <div class="interpsort-product__price" v-if="kidPricing">
                              <span class="interpsort-product__price-tag">{{ translate('intersport.kid-price-text') }}</span>
                              <span>{{ translate('intersport.price-from-text') }} <Price :value="kidPricing.price" /></span>
                            </div>
                          </div>

                          <div class="intersport-product__economy-badge" v-if="productsStore.openProduct.isEconomyProduct">
                            <span class="icon icon-leaf"></span>
                            {{ translate('intersport.economy-badge-text') }}
                          </div>
                        </div>
                      </div>

                      <h6 class="h5 text-secondary mb-4 mb-md-0 mt-4 mt-md-5">{{ translate('intersport.choose-people-for-product-text') }}</h6>
                      <ul class="list-unstyled">
                        <IntersportProductModalPerson v-for="(person, key) in peopleList"
                                                      :id="person.id"
                                                      :firstName="person.firstName"
                                                      :lastName="person.lastName"
                                                      :birthDate="person.birthDate"
                                                      :pricing="person.pricing"
                                                      :additionalData="person.additionalData"
                                                      :conflicts="filterConflicts(person.conflicts)"
                                                      :selected="person.selected"
                                                      :relevantAdditionalData="productsStore.openProduct.relevantAdditionalData"
                                                      :isLastPerson="isLastPerson(peopleList.length - 1, key)" />
                        <li>
                          <div id="add-person-collapse" class="collapse">
                            <form class="intersport-product-modal__add-person js-form-validation" ref="addPersonForm">
                              <div class="row gy-2">
                                <div class="col-12 col-md-6"
                                     v-if="selectablePeople.length > 1">
                                  <CustomSelect
                                    id="people-select"
                                    name="people-select"
                                    class-name="form-group--bold"
                                    :label="translate('intersport.select-person-label')"
                                    :options="selectablePeople"
                                    @change-value="(event: string, isFirstUpdate: boolean) => changeSelectedPerson(event, isFirstUpdate)"/>
                                </div>
                                <div class="col-12 col-md-6">
                                  <Datepicker
                                    class-name="form-group--bold"
                                    min-date="1900-01-01T00:00:00"
                                    max-date="today"
                                    :label="translate('intersport.pick-birth-date-label')"
                                    :id="newPersonBirthDateName"
                                    :name="newPersonBirthDateName"
                                    :placeholder="translate('intersport.pick-birth-date-placeholder')"
                                    :required="true"
                                    :key="[peopleStore.editPerson.birthDate].toString()"
                                    :model-value="peopleStore.editPerson.birthDate"
                                    v-model="peopleStore.editPerson.birthDate"
                                    ref="newPersonBirthDate"/>
                                </div>
                                <div class="col-12 col-md-6" v-for="input in missingAdditionalData">
                                  <FormControl :id="'new-person_' + input.id"
                                               :name="'new-person_' + input.id"
                                               :type="input.type"
                                               :placeholder="input.placeholder"
                                               :label="input.label"
                                               :required="true"
                                               :value="peopleStore.getEditPersonAdditionalDataValue(input.id)"
                                               @update:model-value="peopleStore.changeEditPersonValue('additionalData', $event, input.id)"/>
                                </div>
                              </div>
                              <div class="d-flex flex-column flex-md-row gap-2 justify-content-between mt-3 mt-md-4">
                                <button type="button"
                                        class="btn btn-secondary btn-outline btn-icon-text order-2 order-md-1"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#add-person-collapse"
                                        aria-expanded="false"
                                        aria-controls="#add-person-collapse"
                                        @click="peopleStore.toggleAddPersonCollapse(productsStore.openProduct.relevantAdditionalData)">
                                  <span class="icon icon-close btn-icon-text__icon" aria-hidden="true"></span>
                                  {{ translate('intersport.modal-cancel') }}
                                </button>
                                <div class="d-flex gap-2 order-1 ordre-md-2">
                                  <button type="button"
                                          class="btn btn-green btn-outline btn-icon-text order-1 order-md-2"
                                          @click="peopleStore.addNewPersonFromProductModal(addPersonForm, true)"
                                          v-if="peopleStore.profileRequestUrl">
                                    <span class="icon icon-check btn-icon-text__icon" aria-hidden="true"></span>
                                    {{ translate('intersport.save-to-profile') }}
                                  </button>
                                  <button type="button"
                                          class="btn btn-green btn-icon-text order-1 order-md-2"
                                          @click="peopleStore.addNewPersonFromProductModal(addPersonForm)">
                                    <span class="icon icon-check btn-icon-text__icon" aria-hidden="true"></span>
                                    {{ translate('intersport.modal-save') }}
                                  </button>
                                </div>
                              </div>
                            </form>
                          </div>
                          <button type="button"
                                  data-bs-toggle="collapse"
                                  data-bs-target="#add-person-collapse"
                                  aria-expanded="false"
                                  aria-controls="#add-person-collapse"
                                  :class="addPersonClass"
                                  @click="peopleStore.toggleAddPersonCollapse(productsStore.openProduct.relevantAdditionalData)">
                            <span class="icon icon-accordeon-open btn-icon-text__icon"></span>
                            <span>{{ translate('intersport.sidebox-add-person') }}</span>
                          </button>
                        </li>
                      </ul>
                      <div class="intersport-prodcut-modal__total-price">
                        <span class="intersport-prodcut-modal__total-price-tag">{{ translate('intersport.modal-total-price-tag') }}</span>
                        <strong><Price :value="productsStore.getOpenProductTotalPrice()" /></strong>
                      </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button"
                                class="btn btn-secondary btn-outline btn-icon-text order-2 order-md-1"
                                data-bs-dismiss="modal">
                            <span class="icon icon-close btn-icon-text__icon" aria-hidden="true"></span>
                            {{ translate('intersport.modal-cancel') }}
                        </button>
                        <button type="button"
                                class="btn btn-green btn-icon-text order-1 order-md-2"
                                :disabled="productsStore.getOpenProductSelectedAvailabilities().length === 0"
                                @click="productsStore.saveSelectedAvailabilitiesForProduct()">
                            <span class="icon icon-check btn-icon-text__icon" aria-hidden="true"></span>
                          {{ translate('intersport.modal-save') }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
// @ts-ignore
import { computed, onMounted, onUpdated, ref, nextTick, watch } from "vue";
// @ts-ignore
import { translate } from "@elements/translations";
// @ts-ignore
import * as formValidation from "@elements/form-validation";
// @ts-ignore
import {deepCopy, reassignFormValidationField} from "../utils/utils.ts";
// @ts-ignore
import {AdditionalData, Person, Availability} from "../types/intersport.ts";
import { usePeopleStore } from "../stores/PeopleStore.ts";
import { useProductsStore } from "../stores/ProductStore.ts";
import { useSearchStore } from "../stores/SearchStore.ts";
import Price from "./components/Price.vue";
import IntersportProductModalPerson from "./components/IntersportProductModalPerson.vue";
import Datepicker from "./components/form-elements/Datepicker.vue";
import FormControl from "./components/form-elements/FormControl.vue";
import CustomSelect from "./components/form-elements/CustomSelect.vue";
import LoadingSpinner from "./components/LoadingSpinner.vue";

const peopleStore = usePeopleStore();
const productsStore = useProductsStore();
const searchStore = useSearchStore();
const addPersonForm = ref<HTMLFormElement>();
const newPersonBirthDate = ref<HTMLElement>();

const newPersonBirthDateName = 'new-person-birthDate';

const selectablePeople = computed(() => {
  return peopleStore.getSelectablePeople()
});

const addPersonClass = computed(() => {
  const staticClasses = 'btn btn-nostyling btn-icon-text intersport-product-modal__add-person-btn js-toggle-add-person-collapse';
  return staticClasses + (Object.keys(peopleStore.editPerson).length === 0 || peopleStore.editPerson.id !== '' ? '' : ' d-none');
});

const adultPricing = computed(() => {
  return productsStore.getOpenProductPricing(true);
});

const kidPricing = computed(() => {
  return productsStore.getOpenProductPricing(false);
});

const peopleList = computed(() => {
  let tmpList: Person[] = [];

  if (Object.keys(productsStore.openProduct).length > 0) {
    productsStore.openProduct.availabilities.forEach((availability: Availability) => {
      tmpList.push({...peopleStore.getPersonInfo(availability.personId), ...availability});
    });
  }

  return tmpList;
});

const missingAdditionalData = computed(() => {
  let ids: string[] = [];
  let inputs: AdditionalData[] = [];

  ids = productsStore.openProduct.relevantAdditionalData || [];

  peopleStore.additionalData.forEach((item: AdditionalData) => {
    if (ids.includes(item.id)) {
      inputs.push(deepCopy(item));
    }
  })

  return inputs;
});

function isLastPerson (max, index) {
  return max === index;
}

function changeSelectedPerson(e: string, isFirstUpdate: boolean) {
  if (!isFirstUpdate) {
    peopleStore.selectPersonFromAccount(e);
  }
}

function filterConflicts(conflicts: string[]) {
  if (conflicts) {
    const tmpArray = conflicts.filter((conflict: string) => conflict !== productsStore.openProduct.id);
    return tmpArray.length > 0 ? tmpArray : null;
  }

  return null;
}

watch(newPersonBirthDate, (newValue: HTMLElement) => {
  if (newValue) {
    reassignFormValidationField(addPersonForm.value, newPersonBirthDateName + 'input');
  }
}, {deep: true});
</script>